/* unplugin-vue-components disabled */import script from "./PostManagement.vue?vue&type=script&setup=true&lang=js"
export * from "./PostManagement.vue?vue&type=script&setup=true&lang=js"

import "./PostManagement.vue?vue&type=style&index=0&id=06a8faa7&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-06a8faa7"]])

export default __exports__